import { Col, Container, Row, Stack } from "react-bootstrap";
import { CaretDownFill, CaretUpFill } from "react-bootstrap-icons";

export default function ListenersHeader({ sortConfig, requestSort }) {
    return (
        <Container fluid className="sticky-top">
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col xs={6} lg onClick={() => requestSort("start_datetime")} className=" align-content-center">
                    <Stack direction="horizontal" className="justify-content-center text-center">
                        <span className="offset-1">Session</span>
                        <span className="col-1">
                            {sortConfig?.key === "start_datetime" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                        </span>
                    </Stack>
                </Col>
                <Col xs={{ span: 2, offset: 2 }} lg={{ span: 2, offset: 0 }} xl={1}>
                    <Row>
                        <Col xs={6} onClick={() => requestSort("sex")} className=" align-content-center">
                            <Stack direction="horizontal" className="justify-content-center text-center">
                                <span className="offset-1">Sex</span>
                                <span className="col-1">
                                    {sortConfig?.key === "sex" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                </span>
                            </Stack>
                        </Col>
                        <Col xs={6} onClick={() => requestSort("age")} className=" align-content-center">
                            <Stack direction="horizontal" className="justify-content-center text-center">
                                <span className="offset-1">Age</span>
                                <span className="col-1">
                                    {sortConfig?.key === "age" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                </span>
                            </Stack>
                        </Col>
                    </Row>
                </Col>
                <Col xs={6} lg onClick={() => requestSort("region")} className=" align-content-center">
                    <Stack direction="horizontal" className="justify-content-center text-center">
                        <span className="offset-1">Region</span>
                        <span className="col-1">
                            {sortConfig?.key === "region" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                        </span>
                    </Stack>
                </Col>
                <Col xs={6} lg={3} xl={2} className=" align-content-center">
                    <Stack direction="horizontal" className="justify-content-center text-center">
                        Income
                    </Stack>
                </Col>
                <Col xs={6} xl={3} className=" align-content-center">
                    <Stack direction="horizontal" className="justify-content-center text-center">
                        Previous Session
                    </Stack>
                </Col>
                <Col xs={6} xl={3} className=" align-content-center">
                    <Stack direction="horizontal" className="justify-content-center text-center">
                        Next Session
                    </Stack>
                </Col>
            </Row>
        </Container>
    );
}
